
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.54 4c.38.1.66.2.82.26l.17.08a8.24 8.24 0 011.92 1.34 6.67 6.67 0 011.66 2.35c.1.25.17.51.24.8l.12.59.17 1 .04.2.07.14c.08.16.21.4.39.7l.35.6.85 1.4a.4.4 0 01-.26.61l-.08.01h-1.22v2.38c-.03.3-.18.57-.4.77l-.1.07a.38.38 0 01-.15.06l-.08.01h-1.77c-.32 0-.47.09-.56.23a.47.47 0 00-.06.17v.1l-.33 2.71-.8-.1.33-2.65c0-.18.04-.4.17-.63.2-.36.57-.58 1.07-.62h1.8l.03-.05.04-.06.01-.05v-2.74c0-.2.14-.36.32-.4h.98l-.29-.5-.24-.4c-.42-.7-.7-1.2-.82-1.5l-.05-.22a7.14 7.14 0 01-.06-.26l-.19-1.1-.02-.07a5.83 5.83 0 00-.24-.9 5.86 5.86 0 00-1.46-2.07 7.5 7.5 0 00-1.8-1.24L11.05 5a6.48 6.48 0 00-4.7-.07l-.33.13c-2.22 1.02-3.3 3.08-3.45 5.77v.52a8.61 8.61 0 001.2 3.48l.3.52c.26.47.77 1.33.89 1.53.18.33.33.68.45 1.07.19.58.31 1.2.38 1.82l.03.34.03.4v.09h-.8v-.18a9.56 9.56 0 00-.4-2.22 5.24 5.24 0 00-.4-.93l-1-1.73c-.9-1.58-1.39-2.86-1.48-4.13a5.22 5.22 0 010-.63c.15-2.85 1.31-5.12 3.66-6.32l.32-.15a7.17 7.17 0 014.79-.32z"}}),_c('path',{attrs:{"fill":"#1D6091","d":"M20.55 12.18a6.1 6.1 0 01.23 8.36l-.18.2-.57-.57a5.3 5.3 0 00.12-7.24l-.17-.19.57-.56zm-.92.88c1.81 1.8 1.9 4.7.23 6.6l-.16.18-.58-.56a4.03 4.03 0 00.1-5.5l-.15-.15.56-.57zm-.9.88a3.57 3.57 0 01.21 4.85l-.13.15-.58-.55c1-1.05 1-2.68.06-3.74l-.13-.14.57-.57z"}})])
          )
        }
      }
    